import { Stack } from '@genial/components';
import React from 'react';

import { useGlobalAssetContext } from '../../contexts';

export const AssetList: React.FC = () => {
  const { selectedTab } = useGlobalAssetContext();

  const SelectedTabAssetList = selectedTab.principalComponent;

  return (
    <Stack pt="stack.xxs">
      <SelectedTabAssetList />
    </Stack>
  );
};
